'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitleTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
/** Prop Receivers */

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.title,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      color = _theme$reactackle$com.color,
      fontWeight = _theme$reactackle$com.fontWeight;
  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + color + ';\n    font-weight: ' + fontWeight + ';\n  ';
};
/** Styles */


var DialogTitleTextStyled = exports.DialogTitleTextStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogTitleTextStyled'
})(['margin:0;', ';'], baseProps);

DialogTitleTextStyled.propTypes = propTypes;
DialogTitleTextStyled.displayName = 'DialogTitleTextStyled';